var u = Object.defineProperty;
var f = (o, t, e) => t in o ? u(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var r = (o, t, e) => f(o, typeof t != "symbol" ? t + "" : t, e);
import { getEnvColor as b } from "../../libs/env-helpers.js";
import { ScalarTooltip as v } from "@scalar/components";
import { ScalarIconGlobe as g } from "@scalar/icons";
import { REGEX as w } from "@scalar/oas-utils/helpers";
import { ViewPlugin as y, EditorView as N, RangeSetBuilder as E, Decoration as C, WidgetType as V } from "@scalar/use-codemirror";
import { defineComponent as k, h as m, createApp as x } from "vue";
import { nanoid as D } from "nanoid";
import { parseEnvVariables as R } from "../../libs/environment-parser.js";
class p extends V {
  constructor(e, i, n, s, a) {
    super();
    r(this, "app");
    r(this, "uid");
    r(this, "environment");
    r(this, "envVariables");
    r(this, "workspace");
    r(this, "isReadOnly");
    this.variableName = e, this.variableName = e, this.environment = i, this.envVariables = n, this.workspace = s, this.isReadOnly = a ?? !1, this.uid = D();
  }
  toDOM() {
    const e = document.createElement("span");
    e.className = "cm-pill", e.textContent = `${this.variableName}`;
    const i = k({
      props: { variableName: { type: String, default: null } },
      render: () => {
        var c;
        const n = this.envVariables ? R(this.envVariables).find((h) => h.key === this.variableName) : void 0, s = (n == null ? void 0 : n.source) === "global", a = s ? "var(--scalar-color-1)" : n && this.environment && this.environment.name !== "No Environment" ? b(this.environment) : "var(--scalar-color-1)";
        e.style.setProperty("--tw-bg-base", a), e.style.opacity = n != null && n.value ? "1" : "0.5";
        const l = (n == null ? void 0 : n.value) || "No value", d = m("div", { class: "flex items-center gap-1 whitespace-nowrap" }, [
          (s || ((c = this.environment) == null ? void 0 : c.name) === "No Environment" && (n == null ? void 0 : n.value)) && m(g, { class: "size-3 -ml-1", icon: "Globe" }),
          m("span", this.variableName)
        ]);
        return m(
          v,
          {
            content: l,
            delay: 0,
            placement: "bottom",
            offset: 6
          },
          {
            default: () => d
          }
        );
      }
    });
    return this.app = x(i, { variableName: this.variableName }), this.app.mount(e), e;
  }
  destroy() {
    this.app && this.app.unmount();
  }
  eq(e) {
    return e instanceof p && e.variableName === this.variableName && e.uid === this.uid;
  }
  ignoreEvent() {
    return !1;
  }
}
const z = (o) => y.fromClass(
  class {
    constructor(t) {
      r(this, "decorations");
      this.decorations = this.buildDecorations(t);
    }
    update(t) {
      (t.docChanged || t.viewportChanged) && requestAnimationFrame(() => {
        this.decorations = this.buildDecorations(t.view), t.view.update([]);
      });
    }
    buildDecorations(t) {
      const e = new E();
      for (const { from: i, to: n } of t.visibleRanges) {
        const s = t.state.doc.sliceString(i, n);
        let a;
        for (; (a = w.VARIABLES.exec(s)) !== null; ) {
          const l = i + a.index, d = l + a[0].length, c = a[1] ?? "";
          e.add(
            l,
            d,
            C.widget({
              widget: new p(
                c,
                o.environment,
                o.envVariables,
                o.workspace,
                o.isReadOnly
              ),
              side: 1
            })
          );
        }
      }
      return e.finish();
    }
  },
  {
    decorations: (t) => t.decorations
  }
), F = N.domEventHandlers({
  keydown(o, t) {
    if (o.key === "Backspace") {
      const { state: e } = t, { from: i, to: n } = e.selection.main;
      if (i === 0 && n === e.doc.length)
        return t.dispatch({
          changes: { from: 0, to: e.doc.length },
          selection: { anchor: 0 }
        }), o.preventDefault(), !0;
      if (i === n && i > 0 && e.doc.sliceString(i - 2, i) === "}}")
        return t.dispatch({
          changes: { from: i - 2, to: n },
          selection: { anchor: i - 2 }
        }), o.preventDefault(), !0;
    }
    return !1;
  }
});
export {
  F as backspaceCommand,
  z as pillPlugin
};
